<section *ngIf="variant === 'accordion'" class="card-wrapper" [ngClass]="{ 'disabled': disabled }">
  <div class="card-wrapper-head" (click)="toggle()">
    <umkt-icon class="card-wrapper-icon" [icon]="icon"></umkt-icon>
    <h3 class="card-wrapper-title">{{title}}</h3>
    <i *ngIf="showCheck" class="bi bi-check-circle card-wrapper-check card-wrapper-check_success"></i>
    <i *ngIf="!showCheck" class="bi bi-x-circle card-wrapper-check card-wrapper-check_error"></i>
  </div>
  <div class="card-wrapper-sep"></div>
  <div class="card-wrapper-body" *ngIf="isOpenAccordion">
    <!-- Loading overlay -->
    <umkt-loading 
      *ngIf="loading" 
      [isLoading]="true" 
      [size]="'md'" 
      [mode]="'contained'"
      [showText]="true"
      [text]="(loadingText || 'shared.messages.loading') | i18n">
    </umkt-loading>

    <!-- Content -->
    <ng-container *ngIf="!loading">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </ng-container>
  </div>
</section>

<div *ngIf="variant === 'default'" class="card">
  <div *ngIf="!hideHeader" class="card-header">
    <div class="card-header-left">
      <div *ngIf="icon" class="icon-wrapper" [ngStyle]="{'background-color': iconBackground, 'color': iconColor}">
        <umkt-icon class="card-wrapper-icon" [icon]="icon"></umkt-icon>
      </div>

      <div class="text-group">
        <span class="card-title">{{ title }}</span>
        <span *ngIf="description" class="card-description">{{ description }}</span>
      </div>
    </div>
  </div>

  <div class="card-body">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>

<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>